import axios from 'api/config'

export function login(params) {
  return axios
    .post('/login.json', { user: params })
    .then(r => r.data)
}



// WEBPACK FOOTER //
// ./src/api/login.js